import moment from "moment"

// 年-月-日
export const handleFormatDate = (value)=> {
  if(value) {
    return moment(value).format('YYYY-MM-DD');
  }
  return '--'
}

// 年-月-日 时:分:秒
export const handleFormatDateAndTime = (value)=> {
  if(value) {
    return moment(value).format('YYYY-MM-DD HH:mm:ss');
  }
  return '--'
}
// 年/月/日 时:分
export const handleFormatDate1 = (value)=> {
  if(value) {
    return moment(value).format('YYYY/MM/DD HH:mm');
  }
  return '--'
}

//  时:分:秒
export const handleFormatDateHHmmss = (value)=> {
  if(value) {
    return moment(value).format('HH:mm:ss');
  }
  return '--'
}
// 年-月-日 时:分:秒
export const handleFormatDateAndTimeNoYear = (value)=> {
  if(value) {
    if(moment(value).format('YYYY') == moment().format('YYYY')) {
      return moment(value).format('MM月DD日 HH:mm');
    }
    return moment(value).format('YYYY年MM月DD日 HH:mm');
  }
  return '--'
}

// 当前距离未来某天相距多少天
export const handleNowToFutureDays = (value)=> {
  if(value) {
    if(value > new Date().getTime()) {
      return moment(value).diff(moment(), 'days');
    }
    return 0;
  }
  return '--'
}

/**
 * (按需导出)
 * import { 方法1 } from 'xxxxx';
 * 
 * (整体导出)
 * import all from 'xxxxx';
 * all.方法1
*/


// 注意：如果想要使其成为自定义过滤器就加在这
export default {
  handleFormatDate,
  handleFormatDateAndTime,
  handleFormatDateAndTimeNoYear,
  handleNowToFutureDays,
}